import * as actions from "./actionTypes";

export const create = (payload: any) => {
  return { type: actions.CREATE, payload };
};

export const setFields = (fields: any) => {
  return { type: actions.SET_FIELDS, fields };
};
